import React from "react";
import styles from "./Row.module.sass";
import Checkbox from "../../../../../components/Checkbox";
import Icon from "../../../../../components/Icon";
import Actions from "../../../../../components/Actions";
import Control from "./Control";
import { downloadContract } from "../../../../../services/contract.service";
import { toast } from "react-toastify";

const Row = ({ item, value, onChange }) => {
    const actions = [
        {
            title: "Télécharger le contrat",
            icon: "download",
            action: () => {
                if (item.originalContract && item.originalContract.document) {
                    downloadContract({ ...item.originalContract, fileField: 'document' });
                } else {
                    toast.error("Aucun document de contrat disponible");
                }
            },
        },
        {
            title: "Télécharger la convention",
            icon: "download",
            action: () => {
                if (item.originalContract && item.originalContract.convention) {
                    downloadContract({ ...item.originalContract, fileField: 'convention' });
                } else {
                    toast.error("Aucune convention disponible");
                }
            },
        },
    ];

    return (
        <div className={styles.row}>
            <div className={styles.col}>
                <Checkbox
                    className={styles.checkbox}
                    value={value}
                    onChange={(e) => onChange(e.target.checked)}
                />
            </div>
            <div className={styles.col}>
                <div
                    className={styles.item}
                >
                    <div className={styles.avatar}>
                        <img src={'/images/content/contract_logo.png'} alt="Logo" />
                    </div>
                    <div className={styles.details}>
                        <div className={styles.product}>{item.product}</div>
                        <div className={styles.date}>
                            <Icon name="clock" size="20" /> {item.date}
                        </div>
                        {item.originalContract?.opco_name && (
                            <div className={styles.opco}>
                                OPCO: {item.originalContract.opco_name}
                            </div>
                        )}
                    </div>
                </div>
                <Actions
                    className={styles.actions}
                    classActionsHead={styles.actionsHead}
                    items={actions}
                />
            </div>
            {/* Colonne pour le statut OPCO */}
            <div className={styles.col}>
                <div className={styles.status}>
                    {item.originalContract?.opco_status || 'En attente'}
                </div>
            </div>
            {/* Colonne de date et contrôle */}
            <div className={styles.col}>
                {item.date}
                <Control
                    className={styles.control}
                    item={item.originalContract}
                />
            </div>
        </div>
    );
};

export default Row;